import { Outlet } from 'react-router-dom';

import { Header } from '@/components/shared/Header';
import { Sidebar } from '@/components/shared/Sidebar';
import { SidebarProvider } from '@/contexts/SidebarContext';

function LayoutContent(): JSX.Element {
  return (
    <div className="flex h-screen overflow-hidden bg-muted/40 dark:bg-muted">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto bg-muted/40 dark:bg-muted">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export function AppLayout(): JSX.Element {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
}
